/* eslint-disable */
import {
  OfferRequest_Source,
  offerRequest_SourceFromJSON,
  offerRequest_SourceToJSON,
} from "../../common/sell/offer_request";

export const protobufPackage = "od_protos.journey.data";

/**
 * Context for tracking parameter fields
 * Next ID: 13
 */
export interface CampaignContext {
  utmSource?: string | undefined;
  utmMedium?: string | undefined;
  utmCampaign?: string | undefined;
  utmTerm?: string | undefined;
  utmContent?: string | undefined;
  utmAdgid?: string | undefined;
  utmNtwk?: string | undefined;
  utmSubsite?: string | undefined;
  utmCta?: string | undefined;
  utmExternalid?: string | undefined;
  utmGeo?: string | undefined;
  utmCat?: string | undefined;
}

/**
 * Context for customer related fields
 * Next ID: 6
 */
export interface CustomerContext {
  customerUuid: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  primaryEmail?: string | undefined;
  primaryPhone?: string | undefined;
}

/**
 * Context for Exclusive Offers
 * Next ID: 8
 */
export interface ExclusiveOffersContext {
  offerBlurPricing?: boolean | undefined;
  offerRangeMax?: number | undefined;
  offerRangeMin?: number | undefined;
  potentialBuyerCount?: number | undefined;
  allPhotoCount?: number | undefined;
  internalPhotoCount?: number | undefined;
  mlsPhotoCount?: number | undefined;
}

/**
 * Context for lead fields
 * Next ID: 4
 */
export interface LeadContext {
  sellerInputUuid?: string | undefined;
  sellerLeadUuid?: string | undefined;
  sellerLeadMarket?: string | undefined;
}

/**
 * Context for Sell Direct
 * Next ID: 7
 */
export interface SellDirectContext {
  offerId: string;
  offerRequestSource: OfferRequest_Source;
  offerHeadlinePrice?: number | undefined;
  offerDenialReason?: string | undefined;
  offerState?: string | undefined;
  dwellingType?: string | undefined;
}

/**
 * Context for Ad Clicks
 * Next ID: 4
 */
export interface AdClickContext {
  /** facbook ad click */
  fbclid?:
    | string
    | undefined;
  /** tiktok ad click */
  ttclid?:
    | string
    | undefined;
  /** google ad click */
  gclid?: string | undefined;
}

function createBaseCampaignContext(): CampaignContext {
  return {
    utmSource: undefined,
    utmMedium: undefined,
    utmCampaign: undefined,
    utmTerm: undefined,
    utmContent: undefined,
    utmAdgid: undefined,
    utmNtwk: undefined,
    utmSubsite: undefined,
    utmCta: undefined,
    utmExternalid: undefined,
    utmGeo: undefined,
    utmCat: undefined,
  };
}

export const CampaignContext = {
  fromJSON(object: any): CampaignContext {
    return {
      utmSource: isSet(object.utmSource) ? String(object.utmSource) : undefined,
      utmMedium: isSet(object.utmMedium) ? String(object.utmMedium) : undefined,
      utmCampaign: isSet(object.utmCampaign) ? String(object.utmCampaign) : undefined,
      utmTerm: isSet(object.utmTerm) ? String(object.utmTerm) : undefined,
      utmContent: isSet(object.utmContent) ? String(object.utmContent) : undefined,
      utmAdgid: isSet(object.utmAdgid) ? String(object.utmAdgid) : undefined,
      utmNtwk: isSet(object.utmNtwk) ? String(object.utmNtwk) : undefined,
      utmSubsite: isSet(object.utmSubsite) ? String(object.utmSubsite) : undefined,
      utmCta: isSet(object.utmCta) ? String(object.utmCta) : undefined,
      utmExternalid: isSet(object.utmExternalid) ? String(object.utmExternalid) : undefined,
      utmGeo: isSet(object.utmGeo) ? String(object.utmGeo) : undefined,
      utmCat: isSet(object.utmCat) ? String(object.utmCat) : undefined,
    };
  },

  toJSON(message: CampaignContext): unknown {
    const obj: any = {};
    if (message.utmSource !== undefined) {
      obj.utmSource = message.utmSource;
    }
    if (message.utmMedium !== undefined) {
      obj.utmMedium = message.utmMedium;
    }
    if (message.utmCampaign !== undefined) {
      obj.utmCampaign = message.utmCampaign;
    }
    if (message.utmTerm !== undefined) {
      obj.utmTerm = message.utmTerm;
    }
    if (message.utmContent !== undefined) {
      obj.utmContent = message.utmContent;
    }
    if (message.utmAdgid !== undefined) {
      obj.utmAdgid = message.utmAdgid;
    }
    if (message.utmNtwk !== undefined) {
      obj.utmNtwk = message.utmNtwk;
    }
    if (message.utmSubsite !== undefined) {
      obj.utmSubsite = message.utmSubsite;
    }
    if (message.utmCta !== undefined) {
      obj.utmCta = message.utmCta;
    }
    if (message.utmExternalid !== undefined) {
      obj.utmExternalid = message.utmExternalid;
    }
    if (message.utmGeo !== undefined) {
      obj.utmGeo = message.utmGeo;
    }
    if (message.utmCat !== undefined) {
      obj.utmCat = message.utmCat;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CampaignContext>, I>>(base?: I): CampaignContext {
    return CampaignContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CampaignContext>, I>>(object: I): CampaignContext {
    const message = createBaseCampaignContext();
    message.utmSource = object.utmSource ?? undefined;
    message.utmMedium = object.utmMedium ?? undefined;
    message.utmCampaign = object.utmCampaign ?? undefined;
    message.utmTerm = object.utmTerm ?? undefined;
    message.utmContent = object.utmContent ?? undefined;
    message.utmAdgid = object.utmAdgid ?? undefined;
    message.utmNtwk = object.utmNtwk ?? undefined;
    message.utmSubsite = object.utmSubsite ?? undefined;
    message.utmCta = object.utmCta ?? undefined;
    message.utmExternalid = object.utmExternalid ?? undefined;
    message.utmGeo = object.utmGeo ?? undefined;
    message.utmCat = object.utmCat ?? undefined;
    return message;
  },
};

function createBaseCustomerContext(): CustomerContext {
  return {
    customerUuid: "",
    firstName: undefined,
    lastName: undefined,
    primaryEmail: undefined,
    primaryPhone: undefined,
  };
}

export const CustomerContext = {
  fromJSON(object: any): CustomerContext {
    return {
      customerUuid: isSet(object.customerUuid) ? String(object.customerUuid) : "",
      firstName: isSet(object.firstName) ? String(object.firstName) : undefined,
      lastName: isSet(object.lastName) ? String(object.lastName) : undefined,
      primaryEmail: isSet(object.primaryEmail) ? String(object.primaryEmail) : undefined,
      primaryPhone: isSet(object.primaryPhone) ? String(object.primaryPhone) : undefined,
    };
  },

  toJSON(message: CustomerContext): unknown {
    const obj: any = {};
    if (message.customerUuid !== "") {
      obj.customerUuid = message.customerUuid;
    }
    if (message.firstName !== undefined) {
      obj.firstName = message.firstName;
    }
    if (message.lastName !== undefined) {
      obj.lastName = message.lastName;
    }
    if (message.primaryEmail !== undefined) {
      obj.primaryEmail = message.primaryEmail;
    }
    if (message.primaryPhone !== undefined) {
      obj.primaryPhone = message.primaryPhone;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CustomerContext>, I>>(base?: I): CustomerContext {
    return CustomerContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CustomerContext>, I>>(object: I): CustomerContext {
    const message = createBaseCustomerContext();
    message.customerUuid = object.customerUuid ?? "";
    message.firstName = object.firstName ?? undefined;
    message.lastName = object.lastName ?? undefined;
    message.primaryEmail = object.primaryEmail ?? undefined;
    message.primaryPhone = object.primaryPhone ?? undefined;
    return message;
  },
};

function createBaseExclusiveOffersContext(): ExclusiveOffersContext {
  return {
    offerBlurPricing: undefined,
    offerRangeMax: undefined,
    offerRangeMin: undefined,
    potentialBuyerCount: undefined,
    allPhotoCount: undefined,
    internalPhotoCount: undefined,
    mlsPhotoCount: undefined,
  };
}

export const ExclusiveOffersContext = {
  fromJSON(object: any): ExclusiveOffersContext {
    return {
      offerBlurPricing: isSet(object.offerBlurPricing) ? Boolean(object.offerBlurPricing) : undefined,
      offerRangeMax: isSet(object.offerRangeMax) ? Number(object.offerRangeMax) : undefined,
      offerRangeMin: isSet(object.offerRangeMin) ? Number(object.offerRangeMin) : undefined,
      potentialBuyerCount: isSet(object.potentialBuyerCount) ? Number(object.potentialBuyerCount) : undefined,
      allPhotoCount: isSet(object.allPhotoCount) ? Number(object.allPhotoCount) : undefined,
      internalPhotoCount: isSet(object.internalPhotoCount) ? Number(object.internalPhotoCount) : undefined,
      mlsPhotoCount: isSet(object.mlsPhotoCount) ? Number(object.mlsPhotoCount) : undefined,
    };
  },

  toJSON(message: ExclusiveOffersContext): unknown {
    const obj: any = {};
    if (message.offerBlurPricing !== undefined) {
      obj.offerBlurPricing = message.offerBlurPricing;
    }
    if (message.offerRangeMax !== undefined) {
      obj.offerRangeMax = message.offerRangeMax;
    }
    if (message.offerRangeMin !== undefined) {
      obj.offerRangeMin = message.offerRangeMin;
    }
    if (message.potentialBuyerCount !== undefined) {
      obj.potentialBuyerCount = message.potentialBuyerCount;
    }
    if (message.allPhotoCount !== undefined) {
      obj.allPhotoCount = message.allPhotoCount;
    }
    if (message.internalPhotoCount !== undefined) {
      obj.internalPhotoCount = message.internalPhotoCount;
    }
    if (message.mlsPhotoCount !== undefined) {
      obj.mlsPhotoCount = message.mlsPhotoCount;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExclusiveOffersContext>, I>>(base?: I): ExclusiveOffersContext {
    return ExclusiveOffersContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExclusiveOffersContext>, I>>(object: I): ExclusiveOffersContext {
    const message = createBaseExclusiveOffersContext();
    message.offerBlurPricing = object.offerBlurPricing ?? undefined;
    message.offerRangeMax = object.offerRangeMax ?? undefined;
    message.offerRangeMin = object.offerRangeMin ?? undefined;
    message.potentialBuyerCount = object.potentialBuyerCount ?? undefined;
    message.allPhotoCount = object.allPhotoCount ?? undefined;
    message.internalPhotoCount = object.internalPhotoCount ?? undefined;
    message.mlsPhotoCount = object.mlsPhotoCount ?? undefined;
    return message;
  },
};

function createBaseLeadContext(): LeadContext {
  return { sellerInputUuid: undefined, sellerLeadUuid: undefined, sellerLeadMarket: undefined };
}

export const LeadContext = {
  fromJSON(object: any): LeadContext {
    return {
      sellerInputUuid: isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : undefined,
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : undefined,
      sellerLeadMarket: isSet(object.sellerLeadMarket) ? String(object.sellerLeadMarket) : undefined,
    };
  },

  toJSON(message: LeadContext): unknown {
    const obj: any = {};
    if (message.sellerInputUuid !== undefined) {
      obj.sellerInputUuid = message.sellerInputUuid;
    }
    if (message.sellerLeadUuid !== undefined) {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.sellerLeadMarket !== undefined) {
      obj.sellerLeadMarket = message.sellerLeadMarket;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LeadContext>, I>>(base?: I): LeadContext {
    return LeadContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LeadContext>, I>>(object: I): LeadContext {
    const message = createBaseLeadContext();
    message.sellerInputUuid = object.sellerInputUuid ?? undefined;
    message.sellerLeadUuid = object.sellerLeadUuid ?? undefined;
    message.sellerLeadMarket = object.sellerLeadMarket ?? undefined;
    return message;
  },
};

function createBaseSellDirectContext(): SellDirectContext {
  return {
    offerId: "",
    offerRequestSource: 0,
    offerHeadlinePrice: undefined,
    offerDenialReason: undefined,
    offerState: undefined,
    dwellingType: undefined,
  };
}

export const SellDirectContext = {
  fromJSON(object: any): SellDirectContext {
    return {
      offerId: isSet(object.offerId) ? String(object.offerId) : "",
      offerRequestSource: isSet(object.offerRequestSource) ? offerRequest_SourceFromJSON(object.offerRequestSource) : 0,
      offerHeadlinePrice: isSet(object.offerHeadlinePrice) ? Number(object.offerHeadlinePrice) : undefined,
      offerDenialReason: isSet(object.offerDenialReason) ? String(object.offerDenialReason) : undefined,
      offerState: isSet(object.offerState) ? String(object.offerState) : undefined,
      dwellingType: isSet(object.dwellingType) ? String(object.dwellingType) : undefined,
    };
  },

  toJSON(message: SellDirectContext): unknown {
    const obj: any = {};
    if (message.offerId !== "") {
      obj.offerId = message.offerId;
    }
    if (message.offerRequestSource !== 0) {
      obj.offerRequestSource = offerRequest_SourceToJSON(message.offerRequestSource);
    }
    if (message.offerHeadlinePrice !== undefined) {
      obj.offerHeadlinePrice = message.offerHeadlinePrice;
    }
    if (message.offerDenialReason !== undefined) {
      obj.offerDenialReason = message.offerDenialReason;
    }
    if (message.offerState !== undefined) {
      obj.offerState = message.offerState;
    }
    if (message.dwellingType !== undefined) {
      obj.dwellingType = message.dwellingType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellDirectContext>, I>>(base?: I): SellDirectContext {
    return SellDirectContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellDirectContext>, I>>(object: I): SellDirectContext {
    const message = createBaseSellDirectContext();
    message.offerId = object.offerId ?? "";
    message.offerRequestSource = object.offerRequestSource ?? 0;
    message.offerHeadlinePrice = object.offerHeadlinePrice ?? undefined;
    message.offerDenialReason = object.offerDenialReason ?? undefined;
    message.offerState = object.offerState ?? undefined;
    message.dwellingType = object.dwellingType ?? undefined;
    return message;
  },
};

function createBaseAdClickContext(): AdClickContext {
  return { fbclid: undefined, ttclid: undefined, gclid: undefined };
}

export const AdClickContext = {
  fromJSON(object: any): AdClickContext {
    return {
      fbclid: isSet(object.fbclid) ? String(object.fbclid) : undefined,
      ttclid: isSet(object.ttclid) ? String(object.ttclid) : undefined,
      gclid: isSet(object.gclid) ? String(object.gclid) : undefined,
    };
  },

  toJSON(message: AdClickContext): unknown {
    const obj: any = {};
    if (message.fbclid !== undefined) {
      obj.fbclid = message.fbclid;
    }
    if (message.ttclid !== undefined) {
      obj.ttclid = message.ttclid;
    }
    if (message.gclid !== undefined) {
      obj.gclid = message.gclid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdClickContext>, I>>(base?: I): AdClickContext {
    return AdClickContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdClickContext>, I>>(object: I): AdClickContext {
    const message = createBaseAdClickContext();
    message.fbclid = object.fbclid ?? undefined;
    message.ttclid = object.ttclid ?? undefined;
    message.gclid = object.gclid ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
